import React from "react";
import { Button, Card } from "react-bootstrap";
import { ChevronDown, Edit2 } from "react-feather";

// Shared header for editable detail/settings cards. Omit onToggle for a
// card that isn't collapsible (no chevron, always shows the edit control).
const DetailCardHeader = ({ title, canEdit, editing, expanded = true, onToggle, onEdit, onSave, onCancel }) => {
  const titleEl = <Card.Title as="h5" className="mb-0">{title}</Card.Title>;
  return (
    <Card.Header style={{ display: "flex", alignItems: "center", justifyContent: "space-between", gap: 8, paddingBottom: 12 }}>
      {onToggle ? (
        <button
          type="button"
          onClick={onToggle}
          aria-expanded={expanded}
          aria-label={(expanded ? "Collapse " : "Expand ") + title}
          style={{ display: "flex", alignItems: "center", gap: 8, background: "none", border: 0, padding: 0, textAlign: "left", color: "inherit", cursor: "pointer" }}
        >
          <ChevronDown
            size={16}
            style={{ color: "#8a929a", transition: "transform 0.2s", transform: expanded ? "none" : "rotate(-90deg)" }}
          />
          {titleEl}
        </button>
      ) : titleEl}
      {canEdit && expanded ? (
        editing ? (
          <span className="d-flex gap-2">
            <Button variant="outline-secondary" size="sm" onClick={onCancel}>Cancel</Button>
            <Button variant="primary" size="sm" onClick={onSave}>Save</Button>
          </span>
        ) : (
          <Button variant="link" size="sm" className="p-1 lh-1" onClick={onEdit} aria-label={"Edit " + title} title="Edit">
            <Edit2 size={16} />
          </Button>
        )
      ) : null}
    </Card.Header>
  );
};

export default DetailCardHeader;
